import React from 'react';
import { Table, EllipsisDropdown, AvatarGroup, ButtonLink, ControlledPopup } from 'dyl-components';
import { Dropdown, DropdownItem, Header, Popup } from 'semantic-ui-react';
import { PhoneUtil, StringUtils } from 'utils';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';
import '../index.scss';
import Destinations from './Destinations';

const Row = ({ number = {}, onSelectExternalNumber, onDelete, selectVerifyingPhone, isPhoneTab }) => {
    const { phone, shared, type, label, forward, verified, users, in_use } = number;
    const { cid_display, after_destination } = forward || {};
    return (
        <Table.Row>
            <Table.Cell>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span>
                        {PhoneUtil.formatPhoneNumber(phone)}
                    </span>
                    { isPhoneTab ?
                        !verified && (
                            <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_ADD} type="disabled" userRestrict>
                                <ButtonLink onClick={() => selectVerifyingPhone(number)} style={{padding: 0, width: "fit-content"}}>
                                    Verify
                                </ButtonLink>
                            </RestrictedView>
                        )
                        :                   
                        !verified && (
                            <ButtonLink onClick={() => selectVerifyingPhone(number)} style={{padding: 0, width: "fit-content"}}>
                                Verify
                            </ButtonLink>
                    )}
                </div>
            </Table.Cell>
            <Table.Cell>
                {shared ? "Yes" : "No"}
            </Table.Cell>
            <Table.Cell>
                {StringUtils.capitalize(type)}
            </Table.Cell>
            <Table.Cell>
                <div style={{ display: 'flex'}}>
                    <AvatarGroup
                        persons={users?.map(user => ({ ...user, inactive: !user.active }))}
                        limit={3}
                        size='3em'
                    />
                </div>
            </Table.Cell>
            <Table.Cell>
                {label}
            </Table.Cell>
            <Table.Cell>
                {cid_display}
            </Table.Cell>
            <Table.Cell>
                {!!forward ? "Yes" : "No"}
            </Table.Cell>
            <Table.Cell>
                <Destinations destination={after_destination} />
            </Table.Cell>
            {!isPhoneTab && <Table.Cell>
                <EllipsisDropdown>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_EDIT}>
                        <DropdownItem
                            text={"Edit"}
                            icon={"fa-solid fa-pencil"}
                            onClick={() => { onSelectExternalNumber(phone) }}
                        />
                    </RestrictedView>
                    <RestrictedView type='controlledPopupDisabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_DELETE}>
                        <ControlledPopup 
                            trigger={            
                                !!in_use ? (
                                    <Popup
                                        content="External number in use"
                                        position="right center"
                                        inverted
                                        on={'hover'}
                                        trigger={
                                                <Dropdown.Item 
                                                    className={`external-number-${
                                                        !!in_use ? "disable" : ""
                                                    }`} 
                                                    icon={'fas fa-trash-alt'} 
                                                    text={"Delete"} 
                                            />
                                        }
                                    />
                                ) : (
                                    <Dropdown.Item
                                        text="Delete"
                                        icon="fa-solid fa-trash"
                                    />
                                )
                            }
                            header={
                                <Header as='h4' textAlign='center'>
                                    Are you sure?
                                    <Header.Subheader style={{ marginTop: 5 }}>
                                        You cannot undo delete actions.
                                    </Header.Subheader>
                                </Header>
                            }
                            onConfirm={() => onDelete(phone)}
                            inverted
                        />
                    </RestrictedView>
                </EllipsisDropdown>      
            </Table.Cell>}
        </Table.Row>
    );
}

export default Row;


